import React, { useEffect } from 'react'
import { Button, Card, Form, Input } from 'antd'
import { $isSuccessCreate, closeModal, submitCreatePermission } from './model'
import { useUnit } from 'effector-react'
import { useNavigate } from 'react-router-dom'
import { path } from '../../../../libs'

interface FormData {
  name: string
  description: string
}

export const CreatePermission = () => {
  const navigate = useNavigate()
  const [form] = Form.useForm<FormData>()

  const [isSuccessCreate, modalCloseFn] = useUnit([
    $isSuccessCreate,
    closeModal,
  ])

  useEffect(() => {
    if (isSuccessCreate) {
      navigate(path.permissions.entry())
      modalCloseFn()
    }
  }, [isSuccessCreate])

  const onFinish = (values: FormData) => {
    submitCreatePermission(values)
  }

  return (
    <Card title={<strong>Create permission</strong>}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        style={{ maxWidth: 520 }}
        initialValues={{ name: '', description: '' }}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: 'Имя обязательно' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
    </Card>
  )
}
